import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { useTheme, styled, keyframes } from '@mui/material/styles';
import { Box, Grid, IconButton, Typography } from '@mui/material';

// project import
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import ThemeToggle from './ThemeToggle';
import { drawerWidth } from 'config.js';

// assets
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import SidebarImage from 'assets/images/eurekalogo.png';

// Premium Animations
const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
`;

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.4); }
  70% { box-shadow: 0 0 0 8px rgba(25, 118, 210, 0); }
  100% { box-shadow: 0 0 0 0 rgba(25, 118, 210, 0); }
`; 

// ==============================|| HEADER ||============================== //

const Header = ({ drawerToggle }) => {
  const theme = useTheme();

  return (
    <>
      <Box width={drawerWidth} sx={{ 
        zIndex: 1201,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: 'linear-gradient(90deg, #1976d2, #42a5f5, #1976d2)',
          backgroundSize: '200% 100%',
          animation: `${shimmer} 3s ease-in-out infinite`
        }
      }}>
        <Grid container justifyContent="space-between" alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Grid item>
              <Box mt={0.5} sx={{ position: 'relative', pl: 1 }}>
                <Typography 
                  variant="subtitle2" 
                  sx={{ 
                    color: '#ffffff',
                    fontWeight: 700,
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                    letterSpacing: '2px'
                  }}
                >
                  EUREKA GROUP
                </Typography>
              </Box>
            </Grid>
          </Box>
          <Grid item>
            <IconButton
              edge="start"
              sx={{ 
                mr: theme.spacing(1.25),
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  background: 'linear-gradient(45deg, rgba(25, 118, 210, 0.1), rgba(66, 165, 245, 0.1))',
                  animation: `${float} 2s ease-in-out infinite`,
                  zIndex: -1
                }
              }}
              color="inherit"
              aria-label="open drawer"
              onClick={drawerToggle}
              size="large"
            >
              <MenuTwoToneIcon sx={{ fontSize: '1.5rem' }} />
            </IconButton>
          </Grid>
        </Grid>
        
        {/* Floating Decorative Elements */}
        <Box sx={{
          position: 'absolute',
          top: '20%',
          right: '10%',
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: 'linear-gradient(45deg, rgba(25, 118, 210, 0.2), rgba(66, 165, 245, 0.2))',
          animation: `${float} 4s ease-in-out infinite`,
          zIndex: 0
        }} />
        <Box sx={{
          position: 'absolute',
          top: '60%',
          right: '5%',
          width: 4,
          height: 4,
          borderRadius: '50%',
          background: 'linear-gradient(45deg, rgba(25, 118, 210, 0.15), rgba(66, 165, 245, 0.15))',
          animation: `${float} 5s ease-in-out infinite reverse`,
          zIndex: 0
        }} />
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <SearchSection theme="light" />
      <ThemeToggle />
      <ProfileSection />
    </>
  );
};

Header.propTypes = {
  drawerToggle: PropTypes.func
};

export default Header;
